<div class="dhs-dashboard">
  <div class="good-morning-blk mt-0" style="box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12) !important;">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="morning-user">
          <h2>{{ 'Home.Welcome.TitlePrefix' | translate }} <span>{{ 'Home.Welcome.Brand' | translate }}</span></h2>
          <p>{{ 'Home.Welcome.Subtitle' | translate }}</p>
        </div>
      </div>
      <div class="col-md-auto position-blk">
        <div class="weather-card d-none">
          <div class="weather-info">
            <div class="temperature">18.4 °C</div>
            <div class="date">Tuesday, April 23</div>
            <div class="location">Heliopolis, EG</div>
            <div class="description">Maxima 18.4 °C, Minima 9.2 °C.</div>
          </div>
          <div class="weather-icon">
            <i class="fas fa-sun"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dashboard Widgets -->
  <div class="dhs-widgets-grid">
    <div class="dhs-widget dhs-widget--patients dhs-fade-in" style="animation-delay: 0.1s;">
      <div class="dhs-widget__header">
        <div class="dhs-widget__title">{{ 'Home.Widgets.RegisteredPatients' | translate }}</div>
        <div class="dhs-widget__icon">
          <i class="fas fa-user-injured"></i>
        </div>
      </div>
      <div class="dhs-widget__value">{{homeDashboardResponse?.RegisteredPatientsCount}}</div>
      <div class="dhs-widget__footer">
        <span><i class="far fa-clock"></i> {{ 'Home.Common.Today' | translate }}: {{homeDashboardResponse?.TodayPatientsCount}}</span>
         
      </div>
    </div>

    <div class="dhs-widget dhs-widget--doctors dhs-fade-in" style="animation-delay: 0.2s;">
      <div class="dhs-widget__header">
        <div class="dhs-widget__title">{{ 'Home.Widgets.ActiveDoctors' | translate }}</div>
        <div class="dhs-widget__icon">
          <i class="fas fa-user-md"></i>
        </div>
      </div>
      <div class="dhs-widget__value">{{homeDashboardResponse?.ActiveDoctorsCount}}</div>
      <div class="dhs-widget__footer">
        <span><i class="fas fa-stethoscope"></i>{{ 'Home.Common.Today' | translate }}: {{homeDashboardResponse?.DoctorsWorkTodayCount}}</span>
         
      </div>
    </div>

    <div class="dhs-widget dhs-widget--appointments dhs-fade-in" style="animation-delay: 0.3s;">
      <div class="dhs-widget__header">
        <div class="dhs-widget__title">{{ 'Home.Widgets.TodaysAppointments' | translate }}</div>
        <div class="dhs-widget__icon">
          <i class="fas fa-calendar-check"></i>
        </div>
      </div>
      <div class="dhs-widget__value">{{homeDashboardResponse?.TodayAppointmentsCount}}</div>
      <div class="dhs-widget__footer">
        <span><i class="fas fa-user-clock"></i> {{ 'Home.Common.CheckIn' | translate }}: {{homeDashboardResponse?.TodayCheckedInAppointmentsCount}}</span>
         
      </div>
    </div>

    <div class="dhs-widget dhs-widget--emergency dhs-fade-in" style="animation-delay: 0.4s;">
      <div class="dhs-widget__header">
        <div class="dhs-widget__title">{{ 'Home.Widgets.TotalAdmission' | translate }}</div>
        <div class="dhs-widget__icon">
          <i class="fas fa-ambulance"></i>
        </div>
      </div>
      <div class="dhs-widget__value">{{homeDashboardResponse?.TotalAdmissionsCount}}</div>
      <div class="dhs-widget__footer">
        <span><i class="fas fa-exclamation-triangle"></i> {{ 'Home.Common.Today' | translate }}: {{homeDashboardResponse?.TodayAdmissionsCount}}</span>
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="dhs-charts-grid">
    <!-- Patient Distribution Chart -->
    <div class="dhs-chart dhs-fade-in" style="animation-delay: 0.7s;">
      <div class="dhs-chart__header">
        <div class="dhs-chart__title">
          <i class="fas fa-map-marked-alt"></i> {{ 'Home.Charts.OutPatientDistribution' | translate }}
        </div>
        <div class="dhs-chart__actions">
          <a href="#"><i class="fas fa-expand"></i></a>
          <a href="#"><i class="fas fa-download"></i></a>
        </div>
      </div>
      <div style="height: 250px;">
        <canvas #zoneChart></canvas>
      </div>
    </div>

    <!-- Department Appointments Chart -->
    <div class="dhs-chart dhs-fade-in" style="animation-delay: 0.8s;">
      <div class="dhs-chart__header">
        <div class="dhs-chart__title">
          <i class="fas fa-chart-pie"></i> {{ 'Home.Charts.DepartmentAppointments' | translate }}
        </div>
        <div class="dhs-chart__actions">
          <a href="#"><i class="fas fa-expand"></i></a>
          <a href="#"><i class="fas fa-download"></i></a>
        </div>
      </div>
      <div style="height: 250px;" class="d-flex justify-content-center">
        <canvas #deptChart></canvas>
      </div>
    </div>

    <!-- Medical Statistics Chart -->
    <div class="dhs-chart dhs-fade-in" style="animation-delay: 0.9s;">
      <div class="dhs-chart__header">
        <div class="dhs-chart__title">
          <i class="fas fa-heartbeat"></i> {{ 'Home.Charts.MedicalStatistics' | translate }}
        </div>
        <div class="dhs-chart__actions">
          <a href="#"><i class="fas fa-expand"></i></a>
          <a href="#"><i class="fas fa-download"></i></a>
        </div>
      </div>
      <div style="height: 250px;">
        <canvas #medicalChart></canvas>
      </div>
    </div>
  </div>

  <!-- Patient Flow Visualization -->
  <div class="dhs-patient-flow dhs-fade-in" style="animation-delay: 0.5s;">
    <div class="dhs-patient-flow__title">
      <i class="fas fa-random"></i> {{ 'Home.PatientFlow.Title' | translate }}
    </div>
    <div class="dhs-patient-flow__steps">
      <div class="dhs-patient-flow__line"></div>
      <div class="dhs-patient-flow__progress" style="width: 65%;"></div>

      <div class="dhs-patient-flow__step">
        <div class="dhs-patient-flow__step-icon">
          <i class="fas fa-sign-in-alt"></i>
        </div>
        <div class="dhs-patient-flow__step-label">{{ 'Home.PatientFlow.CheckedIn' | translate }}</div>
        <div class="dhs-patient-flow__step-count">{{patientFlowStatusResponse?.CheckedInCount}}</div>
      </div>

      <div class="dhs-patient-flow__step">
        <div class="dhs-patient-flow__step-icon">
          <i class="fas fa-flask"></i>
        </div>
        <div class="dhs-patient-flow__step-label">{{ 'Home.PatientFlow.LabTests' | translate }}</div>
        <div class="dhs-patient-flow__step-count">{{patientFlowStatusResponse?.LabTestsCount}}</div>
      </div>

      <div class="dhs-patient-flow__step">
        <div class="dhs-patient-flow__step-icon">
          <i class="fas fa-x-ray"></i>
        </div>
        <div class="dhs-patient-flow__step-label">{{ 'Home.PatientFlow.Imaging' | translate }}</div>
        <div class="dhs-patient-flow__step-count">{{patientFlowStatusResponse?.ImagingCount}}</div>
      </div>

      <div class="dhs-patient-flow__step">
        <div class="dhs-patient-flow__step-icon">
          <i class="fas fa-pills"></i>
        </div>
        <div class="dhs-patient-flow__step-label">{{ 'Home.PatientFlow.Pharmacy' | translate }}</div>
        <div class="dhs-patient-flow__step-count">{{patientFlowStatusResponse?.PharmacyCount}}</div>
      </div>

      <div class="dhs-patient-flow__step">
        <div class="dhs-patient-flow__step-icon">
          <i class="fas fa-procedures"></i>
        </div>
        <div class="dhs-patient-flow__step-label">{{ 'Home.PatientFlow.Admitted' | translate }}</div>
        <div class="dhs-patient-flow__step-count">{{patientFlowStatusResponse?.AdmittedCount}}</div>
      </div>

      <div class="dhs-patient-flow__step">
        <div class="dhs-patient-flow__step-icon">
          <i class="fas fa-sign-out-alt"></i>
        </div>
        <div class="dhs-patient-flow__step-label">{{ 'Home.PatientFlow.Discharged' | translate }}</div>
        <div class="dhs-patient-flow__step-count">{{patientFlowStatusResponse?.DischargedCount}}</div>
      </div>
    </div>
  </div>

  <!-- Emergency Alerts -->
  <!-- <div class="dhs-emergency-alerts dhs-fade-in" style="animation-delay: 0.6s;">
    <div class="dhs-emergency-alerts__header">
      <div class="dhs-emergency-alerts__title">
        <i class="fas fa-bell"></i> Emergency Alerts
      </div>
      <div class="dhs-emergency-alerts__badge">3 Critical</div>
    </div>

    <div class="dhs-emergency-alerts__item">
      <i class="fas fa-heartbeat"></i>
      <div>
        <strong>Code Blue - Ward 3B</strong>
        <div>Cardiac Arrest - Dr. Smith attending</div>
      </div>
    </div>

    <div class="dhs-emergency-alerts__item">
      <i class="fas fa-ambulance"></i>
      <div>
        <strong>Trauma Case - ER</strong>
        <div>Motor accident - 2 patients incoming</div>
      </div>
    </div>

    <div class="dhs-emergency-alerts__item">
      <i class="fas fa-exclamation-triangle"></i>
      <div>
        <strong>Medication Error</strong>
        <div>Patient ID #P-4256 - Review required</div>
      </div>
    </div>
  </div> -->
</div>
 
